module.exports = __webpack_public_path__ + "img/1543060650.48921bd5.jpg";